export default {
  login: {
    name1: 'Welcome to LEADEER Cloud IoT Platform',
    name2: 'Please enter your email',
    name3: 'Please enter your password',
    name4: 'Please enter the verification code',
    name5: 'Remember me',
    name6: 'Forgot password?',
    name7: 'Login',
    name8: 'Get demo account',
    name9: 'Back to official version',
    name10: 'Register for trial version',
    name11: 'Nanjing Lishui Electronics Research Institute @ 2025 Listek',
    name12: 'Login to ListekIOT Trial Version',
    name13: 'Demo Account',
    name14: 'Account Name',
    name15: 'Demo Website',
    name16: 'Account',
    name17: 'Password',
    name18: 'One-click Login',
    name19: 'Login Now',
    name20: 'Account:',
    name21: 'Password:',
    name22: 'Forgot Password',
    name23: 'Please enter login name',
  },
  register: {
    name1: 'Back to official version',
    name2: 'Register for ListekIOT Trial Version',
    name3: 'Please enter company name',
    name4: 'Please enter email',
    name5: 'Please enter verification code',
    name6: 'Get verification code',
    name7: 'Please enter password',
    name8: 'Re-enter password',
    name9: 'Read',
    name10: 'Privacy Policy',
    name11: 'Register Now',
    name12: 'Already have an account? Login now',
    name13: 'Lishui Electronics Research Institute @ 2025 Listek',
    name14: 'Registered successfully!',
  },
  retrievePassword: {
    name1: 'Return',
    name2: 'Retrieve Password',
    name3: 'Please enter email',
    name4: 'Please enter verification code',
    name5: 'Get verification code',
    name6: 'Please enter password',
    name7: 'Re-enter password',
    name8: 'Submit',
    name9: 'Get demo account',
    name10: 'Lishui Electronics Research Institute @ 2025 Listek',
    name11: 'Please enter mobile phone number',
    name12: 'Send verification code',
    name13: 'Resend',
    name14: 'Please re-enter password',
    name15: 'The two passwords do not match!',
    name16: 'Incorrect mobile phone number format',
    name17: 'Please enter email format',
    name18: 'Incorrect email format',
    name19: 'Password must be at least 6 characters',
    name20: 'Password must contain both numbers and letters',
  },

  tabmenu: {
    name1: 'Home',
    name2: 'Vehicles',
    name3: 'Veh. Upgrade',
    name4: 'Hist. Vis. Report',
    name5: 'Wired Upgrade',
    name6: 'OTA MGT',
    name7: 'Vehicle MGT',
    name8: 'IOT List',
    name9: 'Model List',
    name10: 'FW Upgrade',
    name11: 'Fault MGT',
    name12: 'Finance',
    name13: 'IoT Charging',
    name14: 'SIM Cards',
    name15: 'Operation',
    name16: 'App Operation',
    name17: 'App Launch',
    name18: 'App Users',
    name19: 'Management',
    name20: 'Sys User MGT',
    name21: 'User List',
    name22: 'User Roles',
    name23: 'Permissions',
    name24: 'Sys Logs',
    name25: 'Mfr User MGT',
    name26: 'Mfr List',
    name27: 'Mfr Users',
    name28: 'Merchant MGT',
    name29: 'Merchant List',
    name30: 'Merchant Users',
    name31: 'Franchisee List',
    name32: 'Franchisee Users',
    name33: 'Notifications',
    name34: 'Settings',
    name35: 'Perm. Scope',
    name36: 'Mfr Roles',
    name37: 'Merchant Roles',
    name38: 'Riding List',
    name39: 'Route List',
    name40: 'Riding MGT',
    name41: 'IoT List',
    name42: 'Feedback List',
    name43: 'Veh. Orders',
    name44: 'Merchant Intro',
    name45: 'Push List',
    name46: 'Franchisee Roles',
    name47: 'Vis. Report',
    name48: 'Vehicle Analysis',
    name49: 'Data Overview',
    name50: 'Activation Data',
    name51: 'Report Details',
    name52: 'E-Fence',
    name53: 'Vehicle Ops',
    name54: 'Reconciliation',
    name55: 'Batch Upgrade',
    name56: 'Real-time Monitor',
    name57: 'Usage Status',
    name58: 'Fault Stats',
    name59: 'Regional Dist.',
    name60: 'App Config',
    name61: 'Transactions',
    name62: 'Refunds',
    name63: 'Data Summary',
    name64: 'App Analysis',
    name65: 'App Status',
    name66: 'Vehicle List',
    name67: 'Model Summary',
    name68: 'Maintenance',
    name69: 'Sales Records',
    name70: 'Sys Config',
    name71: 'Demo Accounts',
    name72: 'Mfr Service',
  },

  notification: {
    empty: 'No notifications',
    emptyHint: 'Only unread broadcast messages from the last hour are shown',
    loadError: 'Failed to load notifications. Please try again later.',
    defaultTitle: 'System Notification',
    batteryHighTitle: 'Vehicle High Temperature Alert',
    batteryHighContent: 'Vehicle {ebikeId} triggered a high temperature alert!',
    ebikePostureTitle: 'Vehicle Vibration Alert',
    ebikePostureContent: 'Vehicle {ebikeId} triggered a vibration alert!',
    noticeMsgTitle: 'Notice',
    cycleFallTitle: 'Vehicle Fall Alert',
    cycleFallContent: 'Vehicle {ebikeId} triggered a fall alert!',
    fenceWarnTitle: 'Geofence Alert',
    fenceWarnContent: 'Vehicle {ebikeId} triggered a geofence alert!',
    feedbackReplyTitle: 'Feedback Reply',
    ebikeFaultTitle: 'Vehicle Fault Alert',
    ebikeFaultContent: 'Vehicle {ebikeId} reported a fault alert!',
    offLineTitle: 'Vehicle Offline Alert',
    offLineContent: 'Vehicle {ebikeId} is offline!',
    genericVehicleContent: 'Vehicle {ebikeId} triggered an alert'
  },

  home: {
    name1: 'View Details',
    name2: 'Number of Manufacturers',
    name3: 'Number of Merchants Using Lidian IoT',
    name4: 'Number of Merchants',
    name5: 'Accumulated Device IoT Charges',
    name6: 'units',
    name7: 'IoT Device New Add Trend',
    name8: 'Fault Status',
    name9: 'Fault Handling Status',
    name10: 'SIM Card Usage Status',
    name11: 'Accumulated IoT Quantity/unit',
    name12: 'New Add This Month',
    name13: 'Accumulated Activation Quantity/unit',
    name14: 'Accumulated Fault Quantity/case',
    name15: 'Accumulated SIM Card Traffic/M',
    name16: 'Accumulated Manufacturers/unit',
    name17: 'Accumulated Merchants/unit',
    name18: 'New IoT Quantity',
    name19: 'Activated IoT Quantity',
    name20: 'TOP 5 Manufacturers',
    name21: 'Manufacturer/Merchant',
    name22: 'TOP 5 Merchants',
    name23: 'All Vehicles',
    name24: 'Online Vehicles',
    name25: 'Faulty Vehicles',
    name26: 'Battery Level',
    name27: 'Vehicle Status',
    name28: 'Unlocked',
    name29: 'Locked',
    name30: 'In Use',
    name31: 'Account Information',
    name32: 'Change Password',
    name33: 'Account Affiliation:',
    name34: 'Current Login:',
    name35: 'Login Region:',
    name36: 'Last Login:',
    name37: 'Original Password:',
    name38: 'Vehicle Temperature Too High',
    name39: 'Total Users',
    name40: 'Total Online App Users',
    name41: 'Total Offline App Users',
    name42: 'Latest Registered App Users',
    name51: 'LEADEER',
    name52: 'Manufacturer Edition',
    name53: 'Shared Edition',
    name54: 'Rental Edition',
    name55: 'Sales Edition',
    name56: 'Shared Franchisee Edition',
    name57: 'Rental Franchisee Edition',
    name58: 'Sales Franchisee Edition',
    name59: 'Real-time Vehicle Over-temperature Alert',
    name60: 'Please enter original password',
    name61: 'Manufacturer New Add Trend',
    name62: 'New Add Quantity',
    name63: 'Fault New Add Trend',
    name64: 'Fault Quantity',
    name65: 'Traffic Usage Trend',
    name66: 'Activation Quantity',
    name67: 'Merchant New Add Trend',
    name68: 'Fault',
    name69: 'Previous',
    name70: 'Next',
    name71: 'Account Name:',
    name72: 'Motor Status',
    name73: 'Battery Status',
    name74: 'Controller Status',
    name75: 'Sensor Status',
    name76: 'Motor System',
    name77: 'Controller System',
    name78: 'BMS System',
    name79: 'BMS System 1',
    name80: 'Total IoT Count',
    name81: 'Units',
  },
  bike: {
    name1: 'Manufacturer Name:',
    name2: 'Vehicle Model ID:',
    name3: 'Add Vehicle',
    name4: 'Vehicle Model ID',
    name5: 'Manufacturer Name',
    name6: 'Report Time',
    name7: 'Speed',
    name8: 'Altitude',
    name9: 'Controller Voltage',
    name10: 'Controller Current',
    name11: 'Operation',
    name12: 'View',
    name13: 'Delete',
    name14: 'Controller',
    name15: 'Display',
    name16: 'Battery',
    name17: 'Port Number:',
    name18: 'File Name:',
    name19: 'Upgrade Now',
    name20: 'Type:',
    name21: 'Version Number:',
    name22: 'File ID',
    name23: 'Vehicle Model ID',
    name24: 'Version Number',
    name25: 'File Name',
    name26: 'Type',
    name27: 'Size',
    name28: 'File Path',
    name29: 'Creation Time',
    name30: 'Merchant Name:',
    name31: 'Controller Version Number:',
    name32: 'Instrument Version:',
    name33: 'IoT Version:',
    name34: 'Vehicle Model ID:',
    name35: 'Vehicle Status:',
    name36: 'Add IoT ID',
    name37: 'Import IoT ID',
    name38: 'IoT ID',
    name39: 'Manufacturer > Merchant Name',
    name40: 'Vehicle MAC',
    name41: 'IoT ID',
    name42: 'Bound User Account',
    name43: 'Controller Version',
    name44: 'Test Vehicle',
    name45: 'Normal',
    name46: 'Details',
    name47: 'Edit',
    name48: 'Vehicle Model Name:',
    name49: 'Motor Model:',
    name50: 'Battery Signal:',
    name51: 'Vehicle ID',
    name52: 'Vehicle Model Name',
    name53: 'Frame Color',
    name54: 'Motor Model',
    name55: 'Battery Voltage',
    name56: 'Battery Current',
    name57: 'Tire',
    name58: 'Version Model:',
    name59: 'Version Type:',
    name60: 'Upgrade Type',
    name61: 'Version Type',
    name62: 'Version Model',
    name63: 'Upgrade Status',
    name64: 'Upgrade Time',
    name65: 'IoT ID:',
    name66: 'Riding ID:',
    name67: 'Fault Status:',
    name68: 'Fault Type:',
    name69: 'Report Time:',
    name70: 'Riding ID',
    name71: 'Fault Type',
    name72: 'Fault Status',
    name73: 'Report Time',
    name74: 'Fault Details',
    name75: 'Creator ID',
    name76: 'Modifier ID',
    name77: 'Modification Time',
    name78: 'Reviewer ID',
    name79: 'Fault Description',
    name80: 'Fault Picture',
    name81: 'No picture information',
    name82: 'Report Details',
    name83: 'Basic Information',
    name84: 'Report Time:',
    name85: 'Other Information',
    name86: 'Speed:',
    name87: 'Longitude and Latitude:',
    name88: 'Altitude:',
    name89: 'Controller Voltage:',
    name90: 'Controller Current:',
    name91: 'Controller Temperature:',
    name92: 'Throttle Voltage:',
    name93: 'Motor Power:',
    name94: 'Cadence:',
    name95: 'Bluetooth Connection Status:',
    name96: 'GPS Connection Status:',
    name97: 'Instrument Connection Status:',
    name98: 'IoT ID:',
    name99: 'Test Vehicle:',
    name100: 'Template Download:',
    name101: 'Template Download',
    name102: 'Upload IoT ID:',
    name103: 'Upload Attachment',
    name104: 'Test',
    name105: 'Merchant Name',
    name106: 'Instrument Version',
    name107: 'IoT Version',
    name108: 'Frame Bottom Bracket ID',
    name109: 'Motor ID',
    name110: 'Remarks',
    name111: 'Transport Status',
    name112: 'Status',
    name113: 'Fault',
    name114: 'Unbind',
    name115: 'Bind',
    name116: 'Import Bottom Bracket Code',
    name117: 'Transport Mode',
    name118: 'Version Configuration',
    name119: 'Assign Operator',
    name120: 'Vehicle Model Binding',
    name121: 'Total Mileage:',
    name122: 'Maximum Power:',
    name123: 'Minimum Power:',
    name124: 'Maximum Voltage:',
    name125: 'Minimum Voltage:',
    name126: 'Maximum Speed:',
    name127: 'Maximum Controller Temperature:',
    name128: 'Minimum Controller Temperature:',
    name129: 'Fault Time',
    name130: 'Corresponding Code',
    name131: 'Fault Definition',
    name132: 'No Location Information',
    name133: 'No Fault Data',
    name134: 'Voltage and Current Summary',
    name135: 'Temperature Summary',
    name136: 'Power/Speed Summary',
    name137: 'Controller Temperature',
    name138: 'Motor Temperature',
    name139: 'Battery Temperature',
    name140: 'Power Percentage',
    name141: 'Speed',
    name142: 'Battery Voltage',
    name143: 'Battery Current',
    name144: 'Temperature',
    name145: 'Report Start Time:',
    name146: 'Add Report',
    name147: 'Report Start Time',
    name148: 'Report End Time',
    name149: 'Export Excel Data',
    name150: 'Manufacturer:',
    name151: 'Report End Time:',
    name152: 'Battery Model:',
    name153: 'Battery Model',
    name154: 'Battery Capacity',
    name155: 'Sensor',
    name156: 'Assign Affiliation',
    name157: 'Import Assigned Affiliation',
    name158: 'Import IoT',
    name159: 'Export Vehicle Information',
    name160: 'Manufacturer/Merchant/Franchisee:',
    name161: 'Vehicle Details',
    name162: 'Modify Remarks',
    name163: 'Basic Vehicle Information',
    name164: 'Vehicle Code:',
    name165: 'Vehicle MAC:',
    name166: 'Warehousing Time:',
    name167: 'Track Time:',
    name168: 'Heartbeat Time:',
    name169: 'Longitude:',
    name170: 'Latitude:',
    name171: 'Altitude:',
    name172: 'Controller Model:',
    name173: 'Controller Temperature Offset:',
    name174: 'Controller Model',
    name175: 'Controller Temperature Offset',
    name176: 'Sensor:',
    name177: 'Tire:',
    name178: 'Battery Capacity:',
    name179: 'Battery Current:',
    name180: 'Battery Voltage (V):',
    name181: 'Battery Model:',
    name182: 'Motor Model:',
    name183: 'Frame Color:',
    name184: 'Vehicle Model Name:',
    name185: 'Add New Vehicle Model',
    name186: 'Vehicle Condition Picture:',
    name187: 'Device Management Picture:',
    name188: 'Manufacturer/Merchant:',
    name189: 'Import Vehicle Model',
    name190: 'Creator Name',
    name191: 'Creator ID',
    name192: 'Route ID',
    name193: 'Creation Time',
    name194: 'Update Time',
    name195: 'Starting Point',
    name196: 'Destination',
    name197: 'Distance (m)',
    name198: 'Route Type',
    name199: 'Personal Route',
    name200: 'Official Route',
    name201: 'Difficulty Coefficient',
    name202: 'Add Route',
    name203: 'Starting Address:',
    name204: 'Destination Address:',
    name205: 'Distance:',
    name206: 'Difficulty Coefficient:',
    name207: 'Road Condition:',
    name208: 'Calorie Consumption:',
    name209: 'Time (min):',
    name210: 'Cover:',
    name211: 'Track Collection:',
    name212: 'Import Vehicle Information',
    name213: 'Import Product Quality Certificate',
    name214: 'Production Information',
    name215: 'View Vehicle Information',
    name216: 'Speed:',
    name217: 'Battery Level:',
    name218: 'Controller Temperature:',
    name219: 'Motor Temperature:',
    name220: 'Battery Temperature:',
    name221: 'Voltage:',
    name222: 'Current:',
    name223: 'Lock Status:',
    name224: 'Unlocked Status',
    name225: 'Locked Status',
    name226: 'Status:',
    name227: 'Fault',
    name228: 'Normal',
    name229: 'Vehicle Information',
    name230: 'Vehicle Alarm Information',
    name231: 'Occurrence Time',
    name232: 'Alarm Status',
    name233: 'Changed',
    name234: 'Unchanged',
    name235: 'IoT Version Number:',
    name236: 'IoT Temp. Display Deviation (℃):',
    name237: 'IoT Temp. Display Alarm Preset (℃):',
    name238: 'Controller ID:',
    name239: 'Controller Temp. Display Deviation (℃):',
    name240: 'Controller Temp. Display Alarm Preset (℃):',
    name241: 'Battery Version Number:',
    name242: 'Battery ID:',
    name243: 'Battery Temp. Display Deviation (℃):',
    name244: 'Battery Temp. Display Alarm Preset (℃):',
    name245: 'Motor Version Number:',
    name246: 'Motor ID:',
    name247: 'Motor Temp. Display Deviation (℃):',
    name248: 'Motor Temp. Display Alarm Preset (℃):',
    name249: 'Instrument ID:',
    name250: 'Instrument Version Number:',
    name251: 'No',
    name252: 'Yes',
    name253: 'Delete Vehicle',
    name254: 'IoT Details',
    name255: 'Basic IoT Information',
    name256: 'Authentication Username:',
    name257: 'Connection Status:',
    name258: 'Port:',
    name259: 'Node:',
    name260: 'IP Address:',
    name261: 'Heartbeat:',
    name262: 'Session Creation Time:',
    name263: 'Session Expiration Time:',
    name264: 'Connection Time:',
    name265: 'Number of Sent Packets:',
    name266: 'Number of Received Packets:',
    name267: 'Number of Received Packets:',
    name268: 'Maximum Unconfirmed Data Packet Count:',
    name269: 'Maximum Flight Window:',
    name270: 'Topics Subscribed by IoT',
    name271: 'IoT Log',
    name272: 'Vehicle IoT ID',
    name273: 'Product Name',
    name274: 'Vehicle Model ID',
    name275: 'Manufacturer or Trademark',
    name276: 'Manufacturer and Address',
    name277: 'Production/Manufacturing Date',
    name278: 'Vehicle ID',
    name279: 'Motor Code',
    name280: 'Drive Mode',
    name281: 'Maximum Design Speed',
    name282: 'Vehicle Weight',
    name283: 'Motor Power and Rated Voltage',
    name284: 'Battery Type',
    name285: 'Length/Width/Height (mm/mm/mm)',
    name286: 'Front and Rear Wheel Center Distance (mm)',
    name287: 'Nameplate Fixed Position',
    name288: 'Vehicle Code Position',
    name289: 'Recommended Service Life',
    name290: 'Whether used for urban logistics, commercial leasing and other operational activities',
    name291: 'China Compulsory Certificate (CCC) Number',
    name292: 'Engraved Vehicle Code',
    name293: 'Vehicle Certificate Photo',
    name294: 'Vehicle IoT ID:',
    name295: 'Vehicle ID:',
    name296: 'Maximum Current:',
    name297: 'Maximum Motor Temperature:',
    name298: 'Maximum Battery Temperature:',
    name299: 'IoT Temp. Display Deviation (℃)',
    name300: 'IoT Temp. Display Alarm Preset (℃)',
    name301: 'Controller Temp. Display Deviation (℃)',
    name302: 'Controller Temp. Display Alarm Preset (℃)',
    name303: 'Battery Temp. Display Deviation (℃)',
    name304: 'Battery Temp. Display Alarm Preset (℃)',
    name305: 'Motor Temp. Display Deviation (℃)',
    name306: 'Motor Tempe. Display Alarm Preset (℃)',
    name307: 'Controller ID',
    name308: 'Battery ID',
    name309: 'Instrument ID',
    name310: 'Sales Status',
    name311: 'Sold',
    name312: 'Unsold',
    name313: 'Manufacturing Date:',
    name314: 'CCC Certificate Number:',
    name315: 'Certificate Expiry Date:',
    name316: 'Product Certificate Number:',
    name317: 'Vehicle Manufacturer:',
    name318: 'Manufacturer Name:',
    name319: 'Vehicle Chinese Trademark:',
    name320: 'Vehicle English Trademark:',
    name321: 'Manufacturer Address:',
    name322: 'Length, Width, Height (mm):',
    name323: 'Weight of Assembled Electric Bicycle (kg):',
    name324: 'Maximum Design Speed (km/h):',
    name325: 'Nameplate Fixed Position:',
    name326: 'Position of Vehicle Code on Frame:',
    name327: 'Range (km):',
    name328: 'Vehicle Outline Drawing Name:',
    name329: 'Battery Type:',
    name330: 'Battery Manufacturer:',
    name331: 'Battery Capacity (Ah):',
    name332: 'Battery Model:',
    name333: 'Battery Weight (kg):',
    name334: 'Battery Length, Width, Height (mm):',
    name335: 'Front and Rear Wheel Center Distance (mm):',
    name336: 'Drive Mode:',
    name337: 'Power Consumption per 100km (Wh):',
    name338: 'Motor Manufacturer:',
    name339: 'Motor Model:',
    name340: 'Motor Type:',
    name341: 'Motor Rated Speed:',
    name342: 'Motor Rated Voltage (V):',
    name343: 'Motor Rated Continuous Output Power (W):',
    name344: 'Controller Manufacturer:',
    name345: 'Controller Model:',
    name346: 'Controller Undervoltage Protection Value (V):',
    name347: 'Controller Overcurrent Protection Value (A):',
    name348: 'Front Tire Specification:',
    name349: 'Rear Tire Specification:',
    name350: 'Implementation Standard Number:',
    name351: 'Load Capacity (kg):',
    name352: 'Battery Nominal Voltage (V):',
    name353: 'Motor Nominal Power (W):',
    name354: 'Brake Type:',
    name355: 'Transmission Specification:',
    name356: 'IoT Manufacturer:',
    name357: 'Edit Vehicle Model',
    name358: 'China Compulsory Certificate (CCC) Number:',
    name359: 'CCC Certificate Status:',
    name360: 'Length (mm):',
    name361: 'Width (mm):',
    name362: 'Height (mm):',
    name363: 'Battery Length (mm):',
    name364: 'Battery Width (mm):',
    name365: 'Battery Height (mm):',
    name366: 'Product Model:',
    name367: 'Production Time:',
    name368: 'Sales Status:',
    name369: 'CCC Material Export',
    name370: 'Vehicle Document Information',
    name371: 'Vehicle Parameter Information',
    name372: 'Certificate Photo:',
    name373: 'Other Photos:',
    name374: 'IoT Model:',
    name375: 'Alarm Time',
    name376: 'IoT F.W Ver.',
    name377: 'IoT H.W Ver.',
    name378: 'Offset Value',
    name379: 'Test Vehicle:',
    name380: 'Please select vehicle',
    name381: 'Are you sure to delete this vehicle?',
    name382: 'Select up to one vehicle',
    name383: 'This operation will change the transport mode, continue?',
    name384: 'Are you sure to unbind the vehicle model?',
    name385: 'Unbind successful!',
    name386: 'Unbind canceled',
    name387: 'Import IoT Information',
    name388: 'Bottom bracket code information imported successfully',
    name389: 'Failed to import IoT information',
    name390: 'Import Bottom Bracket Code Information',
    name391: 'Import IoT information successfully',
    name392: 'Please select manufacturer and attachment',
    name393: 'Import certificate information successfully',
    name394: 'Failed to import certificate information',
    name395: 'Import Certificate Information',
    name396: 'Import vehicle information successfully',
    name397: 'Failed to import vehicle information',
    name398: 'Import Vehicle Information',
    name399: 'Failed to import vehicle factory information',
    name400: 'Import Vehicle Factory Information',
    name401: 'Import vehicle factory information successfully',
    name402: 'Modify Vehicle Factory Information',
    name403: 'Upload vehicle factory info in EXCEL:',
    name404: 'Vehicle Information EXCEL Upload:',
    name405: 'Product Quality Certificate EXCEL Upload:',
    name406: 'Operator Name:',
    name407: 'Vehicle Model Offset',
    name408: 'Vehicle Model EXCEL Upload:',
    name409: 'Vehicle Production Information',
    name410: 'Certificate Picture',
    name411: 'Wired Upgrade',
    name412: 'APP Upgrade',
    name413: 'Instrument',
    name414: 'Offline',
    name415: 'Upgrading',
    name416: 'Success',
    name417: 'Failed',
    name418: 'Upgrade package download failed',
    name419: 'Upgrade package verification error and external device communication failure',
    name420: 'Overvoltage Protection',
    name421: 'Undervoltage Protection',
    name422: 'Controller power tube damage or overcurrent fault',
    name423: 'Locked-rotor Protection',
    name424: 'Motor Hall Fault',
    name425: 'Motor Phase Line Fault',
    name426: 'Throttle Voltage Too High',
    name427: 'Controller/Motor Overtemperature Protection',
    name428: 'Controller Voltage Fault',
    name429: 'Abnormal Power Assist Fault',
    name430: 'MCU Self-test Fault',
    name431: 'Runaway Protection',
    name432: 'Pedal Sensor Fault',
    name433: 'Speed Sensor Fault',
    name434: 'Brake Lever Fault',
    name435: 'Overspeed',
    name436: 'Battery Communication Fault',
    name437: 'Battery Overtemperature',
    name438: 'Instrument Communication Fault',
    name439: 'Client ID',
    name440: 'Subscription Count',
    name441: 'IP Address',
    name442: 'Connection Status',
    name443: 'Connected',
    name444: 'Disconnected',
    name445: 'OTA Source:',
    name446: 'MAC Address:',
    name447: 'Vehicle Debug Report',
    name448: 'Add OTA File',
    name449: 'Edit OTA File',
    name450: 'Maintenance Order ID',
    name451: 'Operator',
    name452: 'Store Address',
    name453: 'Maintenance Time',
    name454: 'Maintenance Type',
    name455: 'Pre-replacement ID',
    name456: 'Post-replacement ID',
    name457: 'Maintenance Picture',
    name458: 'Sales Time',
    name459: 'Invoice Picture',
    name460: 'Failed to modify vehicle factory information',
    name461: 'Modify vehicle factory information successfully',
    name462: 'Product Certification (CCC) Certificate Information',
    name463:
      'Manufacturer has not bound vehicle model, cannot accurately identify controller offset value, which may cause errors in some data results. Please go to vehicle model management to add model and bind to vehicle.',
    name464: 'IoT ID does not exist',
    name465: 'Start Time Point',
    name466: 'End Time Point',
    name467: 'Maintenance Type:',
    name468: 'Please enter vehicle model ID',
    name469: 'Please select operator',
    name470: 'Please select version number',
    name471: 'Please select type',
    name472: 'Please fill in vehicle model ID',
    name473: 'Please enter IoT ID',
    name474: 'Please enter vehicle model name',
    name475: 'Please enter CCC certificate number',
    name476: 'Please select manufacturer',
    name477: 'Please select start time',
    name478: 'Please select end time',
    name479: 'Please enter MAC address',
    name480: 'Please select vehicle model id',
    name481: 'Please select merchant',
    name482: 'Please select file',
    name483: 'Please select time',
    name484: 'Please select time within six hours',
    name485: 'Driving Distance (m)',
    name486: 'Duration (s)',
    name487: 'Start Time',
    name488: 'End Time',
    name489: 'Track Details',
    name490: 'Maintenance Time:',
    name491: 'Sales Time:',
    name492: 'Vehicle MAC ID:',
    name493: 'Device Affiliation:',
    name494: 'Lock Status:',
    name495: '(Negative value is battery charging)',
    name496: 'Beidou Positioning Status',
    name497: 'View Data Source',
    name498: 'Data Upload Time',
    name499: 'Battery Level',
    name500: 'Altitude',
    name501: 'BDS Speed (KM/h)',
    name502: 'Location Data Source',
    name503: 'Battery Temperature (℃)',
    name504: 'Battery Voltage (V)',
    name505: 'Battery Current (A)',
    name506: 'Battery Charging Status',
    name507: 'Power (W)',
    name508: 'Total Mileage (KM)',
    name509: 'Cadence',
    name510: 'Fault Code',
    name511: 'Fault Code Description',
    name512: 'Total Battery Packs',
    name513: 'Battery Pack {num} Voltage (V)',
    name514: 'Power On',
    name515: 'Power Off',
    name516: 'Alarm Enabled',
    name517: 'Charging',
    name518: 'BDS',
    name519: 'Base Station',
    name520: 'Charge',
    name521: 'Discharge',
    name522: 'Speed (KM/h)',
    name523: 'Controller Temperature (℃)',
    name524: 'Motor Temperature (℃)',
    name525: 'Longitude (°)',
    name526: 'Latitude (°)',
    name527: 'Charger model:',
    name528: 'Charger implementation standard:',
    name529: 'Full Vehicle Info Export',
    name530: 'Full Vehicle Info',
    name531: 'IOTReset',
    name532: 'Reset Success',
    name533: 'SMSConfiguration',
    name534: 'Platform Configuration',
    name535: 'Template Management',
    name536: 'SMS Platform',
    name537: 'Region',
    name538: 'Max Daily Sends',
    name539: 'times',
    name540: 'Add Template',
    name541: 'Business Scenario',
    name542: 'Template CODE',
    name543: 'Template Text',
    name544: 'Status',
    name545: 'Test Send',
    name546: 'Save Configuration',
    name547: 'Alibaba Cloud',
    name548: 'AccessKey ID',
    name549: 'AccessKey Secret',
    name550: 'Edit Template',
    name551: 'Phone Number',
    name552: 'Send',
    name553: 'Select Template',
    name554: 'Verification Code',
    name555: 'Battery Warning',
    name556: 'Template Name',
    name557: 'Signature CODE',
    name558: 'Signature Name',
    name559: 'Enable Status',
    name560: 'Enabled',
    name561: 'System Preset (Read-only)',
    name562: 'Disabled',
    name563: 'Param Count',
    name564: 'Should this template be deleted?',
    name565: 'Parameter',
    name566: 'Add Parameter',
    name567: 'Please complete all required platform settings first',
    name568: 'Multiple uses; separate',
    name569: 'View import records',
    name570: 'Upload time',
    name571: 'EXcel',
    name572: 'Download',
    name573: 'Bluetooth Only',
    name574: 'Five-way Code Template Download:',
    name575: 'Five-way Code EXCEL Upload:',
    name576: 'Five-way Code Upload',
    name577: 'Column Configuration',
    name578: 'Modify Vehicle Basic Information',
    name579: 'Perform IoT reset for {ebikeId}?',
    name580: 'Select All',
    name581: 'Save',
    name582: 'No Fault',
    name583: 'Low Battery',
    name584: 'Please select data from the same manufacturer and the same vehicle model ID',
    name585: 'This vehicle already exists',
    name586: 'Charger Manufacturer:',
    name587: 'Charger Unique ID:',
    name588: 'Remote Enable',
    name589: 'Remote Disable',
    name590: 'Unlock Battery',
    name591: 'Lock Battery',
    name592: 'Erase',
    name593: 'More Actions',
    name594: 'IOT {ebikeId} "{action}" succeeded',
    name595: 'IOT {ebikeId} operation failed',
    name596: 'IOT {ebikeId} operation timeout, please retry',
    name597: 'Processing, Please Wait...',
    name598: 'This Vehicle Is Being Processed, Please Wait',
    name599: 'Are You Sure To "{action}" Vehicle {ebikeId}?',
    name601: 'Remote Locking',
    name603: 'Enable Remote Lock',
    name604: 'Disable Remote Lock',
    name605: 'IOT {ebikeId} data was not erased successfully',
    name606: 'IOT {ebikeId} "{action}" failed',
    name607: 'Lock Status',
    name608: 'IOT {ebikeId} data erased successfully',
    name609: 'Erase accessory data for IOT {ebikeId}?',
    name610: 'Erase',
    modelExample: {
      ebikeModelId: 'Please enter such as: KX202504290012',
      ebikeModelName: 'Please enter such as: Road Bike No.1',
      cccCode: 'Please enter such as: 2025011119001230',
      modelColor: 'Please enter such as: Black',
      iotVersionNo: 'Please enter such as: IOT001',
      controllerVersion: 'Please enter such as: KZQ011',
      batteryVersion: 'Please enter such as: DC011',
      motorVersion: 'Please enter such as: DJ011',
      meterVersion: 'Please enter such as: YB001',
      certificateExpireDate: 'Please enter such as: 2026-7-23',
      productModel: 'Please enter such as: LL123421',
      productCertificateNumber: 'Please enter such as: A149878RS11000000',
      certificateStatus: 'Please enter such as: Valid',
      ebikeManufacturer: 'Please enter such as: Phniex Vehicle Manufacturer Co.',
      manufactureEnterpriseName: 'Please enter such as: Phoenix Production Enterprise Co.',
      ebikeCnBrand: 'Please enter such as: N/A',
      ebikeEnBrand: 'Please enter such as: leadeercloud',
      manufactureEnterpriseAddress: 'Please enter such as: Jiangsu Province, Nanjing City, Taiping District, Wujin Street',
      lengthValue: 'Please enter such as: 1260',
      widthValue: 'Please enter such as: 540',
      heightValue: 'Please enter such as: 1056',
      ebikeWeight: 'Please enter such as: 20',
      maxDesignSpeed: 'Please enter such as: 25',
      nameplateFixedPosition: 'Please enter such as: Riveted at the front of the down tube',
      ebikeFrameCodePosition: 'Please enter such as: Char height 6mm, depth 0.2mm, two rows stamped on frame',
      enduranceMileage: 'Please enter such as: 40',
      ebikeOutlinePicName: 'Please enter such as: Road bike',
      batteryType: 'Please enter such as: Lithium-ion',
      batteryManufactureEnterpriseName: 'Please enter such as: Ningde Battery Manufacturer Co.',
      batteryCapacity: 'Please enter such as: 10.4',
      batteryModel: 'Please enter such as: 10S4P',
      batteryVoltage: 'Please enter such as: 36',
      batteryCurrent: 'Please enter such as: 10A',
      batteryWeight: 'Please enter such as: 2.5±0.5',
      batteryLength: 'Please enter such as: 257',
      batteryWidth: 'Please enter such as: 78',
      batteryHeight: 'Please enter such as: 94',
      chargerModel: 'Please enter such as: DZL4830-01-SS',
      chargerStandards: 'Please enter such as: GB42296-2022',
      chargerManufactureEnterpriseName: 'Please enter such as: Shenzhen Nanhai Charger Manufacturer Co., Ltd.',
      beforeAfterWheelDistance: 'Please enter such as: 910',
      driveType: 'Please enter such as: Electric drive and pedal assist',
      hundredKmPowerConsumption: 'Please enter such as: 480',
      motorManufactureEnterprise: 'Please enter such as: Shanghai Motor Co.',
      electricalMachineryModel: 'Please enter such as: JNW90-14',
      motorType: 'Please enter such as: Permanent magnet',
      motorRatedSpeed: 'Please enter such as: 420±10',
      motorRatedVoltage: 'Please enter such as: 36',
      motorRatedOutputPower: 'Please enter such as: 250',
      controllerManufactureEnterprise: 'Please enter such as: Nanjing Keqiao Electric Co., Ltd.',
      controllerModel: 'Please enter such as: 90B',
      controllerUndervoltageProtectionValue: 'Please enter such as: 30.0±1',
      controllerOvercurrentProtectionValue: 'Please enter such as: 15.0±1',
      frontTireSpecifications: 'Please enter such as: 26*1.95',
      rearTireSpecifications: 'Please enter such as: 26*1.95',
      executiveStandardNumber: 'Please enter such as: GB 17761-2018',
      deadweightCapacity: 'Please enter such as: 150',
      batteryNominalVoltage: 'Please enter such as: 50V',
      motorNominalPower: 'Please enter such as: 10W',
      brakeType: 'Please enter such as: Disc brake',
      transmissionSpecifications: 'Please enter such as: TX32',
      iotManufactureEnterprise: 'Please enter such as: Nanjing Lishui Electronics Research Institute Co., Ltd.',
      sensor: 'Please enter such as: Mid-axle torque sensor',
    },
  },
  finance: {
    name1: 'Merchant Name:',
    name2: 'Bill Time:',
    name3: 'Payment Status:',
    name4: 'Generate Bill Manually',
    name5: 'Bill Generation Settings',
    name6: 'Bill Time',
    name7: 'Manufacturer > Merchant Name',
    name8: 'Vehicle Quantity',
    name9: 'Unit Price ($)',
    name10: 'Total ($)',
    name11: 'Remarks',
    name12: 'Payment Status',
    name13: 'Payment Voucher',
    name14: 'Payment Time',
    name15: 'Operation',
    name16: 'Edit',
    name17: 'Edit Payment Status',
    name18: 'Manufacturer > Merchant Name:',
    name19: 'Bill Generation Time:',
    name20: 'Remarks:',
    name21: 'Payment Time:',
    name22: 'Payment Voucher Upload:',
    name23: 'IoT Device Purchase Order:',
    name24: 'Valid Time:',
    name25: 'Vehicle Name:',
    name26: 'IMSI:',
    name27: 'SIM Card ID:',
    name28: 'IoT ID',
    name29: 'IMSI',
    name30: 'SIM Card ID',
    name31: 'Creation Time',
    name32: 'Details',
    name33: 'IoT ID:',
    name34: 'SIM Card Remaining Traffic Information',
    name35: '(Total Traffic:',
    name36: ')',
    name37: 'Used Traffic',
    name38: 'Remaining Traffic',
    name39: 'Manufacturer > Merchant:',
    name40: 'Manufacturer > Merchant',
    name41: 'Please select order status',
    name42: 'Please enter order number',
    name43: 'Please select vehicle model name',
    name44: 'Order Status:',
    name45: 'Order Time:',
    name46: 'Order Start Time',
    name47: 'Order End Time',
    name48: 'Quantity',
    name49: 'Merchant Name',
    name50: 'Vehicle Model ID',
    name51: 'E-contract Upload:',
    name52: 'Modify Merchant Vehicle Order Status',
  },

  operate: {
    name1: 'Merchant Name:',
    name2: 'Search:',
    name3: 'App ID',
    name4: 'Manufacturer Name',
    name5: 'App Name',
    name6: 'App Icon',
    name7: 'Version Number',
    name8: 'Latest Launch Time',
    name9: 'Operation',
    name10: 'Version List',
    name11: 'Add New',
    name12: 'Version Number:',
    name13: 'Version Status:',
    name14: 'Serial Number',
    name15: 'Version ID',
    name16: 'Version Number',
    name17: 'Version Type',
    name18: 'Update Type',
    name19: 'Version Status',
    name20: 'Release Time',
    name21: 'Update Time',
    name22: 'Operation',
    name23: 'Status',
    name24: 'Modify',
    name25: 'Delete',
    name26: 'Fill in Version Information',
    name27: 'Version Description:',
    name28: 'Version Type:',
    name29: 'Update Type:',
    name30: 'Ignorable',
    name31: 'Normal',
    name32: 'Forced',
    name33: 'File:',
    name34: 'Click to Upload',
    name35: 'Version Description:',
    name36: 'Modify Version Status',
    name37: 'Version Number:',
    name38: 'Status:',
    name39: 'Disabled',
    name40: 'Testing',
    name41: 'Released',
    name42: 'Login Account',
    name43: 'Merchant Type',
    name44: 'Nickname',
    name45: 'User ID',
    name46: 'Avatar',
    name47: 'Registration Time',
    name48: 'Enable',
    name49: 'Associate Vehicles',
    name50: 'Reset Password',
    name51: 'Electronic Fence Name:',
    name52: 'Departure Time:',
    name53: 'Electronic Fence Name',
    name54: 'Departure Time ≥ 5 minutes',
    name55: 'Entry Time',
    name56: 'Accumulated In-out Time',
    name57: 'Track Details',
    name58: 'Fence ID:',
    name59: 'Fence Name:',
    name60: 'Fence Type:',
    name61: 'Fence ID',
    name62: 'Fence Name',
    name63: 'Fence Type',
    name64: 'Drawing Type',
    name65: 'Active Area',
    name66: 'Prohibited Area',
    name67: 'Polygon',
    name68: 'Coordinate Point Edit',
    name69: 'Add New Area Fence',
    name70: 'Edit Area Fence',
    name71: 'Drawing Type:',
    name72: 'Map Type:',
    name73: 'Google Maps',
    name74: 'Tianditu Maps',
    name75: 'Track Speed',
    name76: 'Start',
    name77: 'Path Playback',
    name78: 'Pause Playback',
    name79: 'Electronic Fence - Vehicle List',
    name80: 'Search',
    name81: 'Import',
    name82: 'IoT Add',
    name83: 'Electronic Fence - Vehicle List Import',
    name84: 'Track Speed:',
    name85: 'Coordinates saved successfully!',
    name86: 'Order ID:',
    name87: 'User ID:',
    name88: 'Serial Number:',
    name89: 'Payment Platform:',
    name90: 'Time:',
    name91: 'Order ID',
    name92: 'Serial Number',
    name93: 'User ID',
    name94: 'Transaction Amount',
    name95: 'Payment Platform',
    name96: 'Transaction Voucher',
    name97: 'Transaction Time',
    name98: 'All',
    name99: 'Alipay',
    name100: 'WeChat',
    name101: 'PayPal',
    name102: 'Application ID:',
    name103: 'Applicant ID:',
    name104: 'Review Status:',
    name105: 'Application ID',
    name106: 'Applicant ID',
    name107: 'Refund Amount',
    name108: 'Application Time',
    name109: 'Application Status',
    name110: 'Application Result',
    name111: 'Details',
    name112: 'Re-review',
    name113: 'Initial Review',
    name114: 'Refund Reason',
    name115: 'Review ID:',
    name116: 'Application Time:',
    name117: 'Reviewer ID:',
    name118: 'Review Time:',
    name119: 'Review Reason:',
    name120: 'Review Result:',
    name121: 'Refund Voucher (Picture)',
    name122: 'Refund Details',
    name123: 'Review Information',
    name124: 'This operation will proceed to the re-review process?',
    name125: 'This operation will proceed to the initial review process?',
    name126: 'Parking Area',
    name127: 'App ID:',
    name128: 'App Name:',
    name129: 'Merchant List',
    name130: 'Add New Version',
    name131: 'Submitter Name:',
    name132: 'Feedback Title:',
    name133: 'Feedback Status:',
    name134: 'Submitter',
    name135: 'Feedback Title',
    name136: 'Feedback Location',
    name137: 'Feedback Email',
    name138: 'Feedback Time',
    name139: 'Feedback Status',
    name140: 'Custom App Information',
    name141: 'Personal General App Information',
    name142: 'Add APP Information',
    name143: 'Edit APP Information',
    name144: 'App Icon:',
    name145: 'Add General Personal APP Merchant',
    name146: 'E-commerce Center',
    name147: 'User Guide',
    name148: 'Privacy Policy',
    name149: 'Logo Settings',
    name150: 'Preview',
    name151: 'E-commerce URL:',
    name152: 'User Guide Preview',
    name153: 'Privacy Policy Preview',
    name154: 'Please enter link address',
    name155: 'Login Name/Email',
    name156: 'Nickname',
    name157: 'Account Type',
    name158: 'User ID',
    name159: 'Mobile Phone Number',
    name160: 'Connection Time',
    name161: 'Unbind',
    name162: 'Push Message',
    name163: 'Push Information:',
    name164: 'New Password:',
    name165: 'Confirm New Password:',
    name166: 'Route Edit',
    name167: 'Route Usage',
    name168: 'Riding Mode',
    name169: 'Find Vehicle',
    name170: 'Alarm Settings',
    name171: 'Please select area',
    name172: 'Please enter fence name',
    name173: 'Please select fence type',
    name174: 'Please select drawing type',
    name175: 'Please select IoT code',
    name176: 'Feedback Content',
    name177: 'Feedback Picture',
    name178: 'Version Name:',
    name179: 'Download Page Link',
    name180: 'Copy Download Page Link',
    name181: 'Version Name',
    name182: 'Continue Playback',
    name183: 'Please enter app code',
    name184: 'Please select app icon',
    name185: 'Please enter app name',
    name186: 'Please select status',
    name187: 'Please enter version name',
    name188: 'Copied successfully',
    name189: 'Copy failed',
    name190: 'Submitted successfully!',
    name191: 'Push ID',
    name192: 'Sender ID',
    name193: 'Message Type',
    name194: 'Business Code',
    name195: 'Message Code',
    name196: 'Message Time',
    name197: 'Content',
    name198: 'Text',
    name199: 'Please enter version number',
    name200: 'Recommended size: 200*200px, upload up to 1 image',
    name201: 'Please contact LEADEER to create your APP',
    name202: 'Electronic Fence Entry/Exit Log',
    name203: 'Configuration',
    name204: 'No App information',
    name205: 'Download App',
  },

  manage: {
    name1: 'Search:',
    name2: 'Status:',
    name3: 'Add New User',
    name4: 'Login Account',
    name5: 'Username',
    name6: 'Role',
    name7: 'Phone',
    name8: 'Email',
    name9: 'Latest Edit Time',
    name10: 'Last Login Time',
    name11: 'Last Login IP',
    name12: 'Status',
    name13: 'Enable',
    name14: 'Disable',
    name15: 'Operation',
    name16: 'Bind Role',
    name17: 'Edit',
    name18: 'Delete',
    name19: 'Add System User',
    name20: 'Login Account:',
    name21: 'Password:',
    name22: 'Name:',
    name23: 'Nickname:',
    name24: 'Phone:',
    name25: 'Role:',
    name26: 'Email:',
    name27: 'Role Name:',
    name28: 'Role Name',
    name29: 'Permissions',
    name30: 'Add New Role',
    name31: 'Add Identity',
    name32: 'Identity Name:',
    name33: 'Enable:',
    name34: 'On',
    name35: 'Off',
    name36: 'Permissions:',
    name37: 'Permission Name:',
    name38: 'Permission Name',
    name39: 'API Path',
    name40: 'Frontend Permission',
    name41: 'Page Route',
    name42: 'Submenu',
    name43: 'Add Rule',
    name44: 'Type:',
    name45: 'API',
    name46: 'Menu',
    name47: 'API Chinese Name:',
    name48: 'Parent Category:',
    name49: 'Add New Permission',
    name50: 'Request Method:',
    name51: 'API Address:',
    name52: 'Route Address:',
    name53: 'Permission Identifier:',
    name54: 'Sort:',
    name55: 'Icon:',
    name56: 'Note: Upload icon, 200*200 pixels. Only one allowed',
    name57: 'Hide Menu:',
    name58: 'Time:',
    name59: 'Time',
    name60: 'Export',
    name61: 'Operation Account ID',
    name62: 'Operation Account',
    name63: 'Operation Type',
    name64: 'Operation Content',
    name65: 'Manufacturer Name:',
    name66: 'Manufacturer Code',
    name67: 'Manufacturer Name',
    name68: 'Creation Time',
    name69: 'Manufacturer Order Quantity',
    name70: 'Vehicle Model Quantity',
    name71: 'Associated Merchant Quantity',
    name72: 'Contact Information',
    name73: 'Manufacturer Account',
    name74: 'Add',
    name75: 'Manufacturer Code:',
    name76: 'Contact Person:',
    name77: 'Contact Information:',
    name78: 'Remarks:',
    name79: 'Merchant Name',
    name80: 'Merchant Type',
    name81: 'Merchant User Quantity',
    name82: 'Remarks',
    name83: 'IoT Charging Status',
    name84: 'Merchant Account',
    name85: 'Add Merchant List',
    name86: 'Merchant Name:',
    name87: 'Merchant Type:',
    name88: 'Enter',
    name89: 'Add Merchant User',
    name90: 'Franchisee Name:',
    name91: 'Franchisee Name',
    name92: 'Merchant Vehicle Quantity',
    name93: 'Franchisee Account',
    name94: 'Edit System User',
    name95: 'Menu Chinese Name:',
    name96: 'Edit Identity',
    name97: 'Add Manufacturer List',
    name98: 'Edit Manufacturer List',
    name99: 'Add Manufacturer User',
    name100: 'Edit Manufacturer User',
    name101: 'Edit Merchant User',
    name102: 'Add Franchisee User',
    name103: 'Edit Franchisee User',
    name104: 'API English Name:',
    name105: 'Menu English Name:',
    name106: 'All Permissions',
    name107: 'Platform:',
    name108: 'Manufacturer App',
    name109: 'Customer Service Type:',
    name110: 'Content:',
    name111: 'Website and Account',
    name112: 'Account Name:',
    name113: 'Website:',
    name114: 'Name:',
    name115: 'Permission Configuration',
    name116: 'Lidian',
    name117: 'Manufacturer',
    name118: 'Brand Merchant',
    name119: 'Brand Merchant Franchisee',
    name120: 'Shared Merchant',
    name121: 'Rental Merchant',
    name122: 'Shared Franchisee',
    name123: 'Rental Franchisee',
    name124: 'H5 Permission',
    name125: 'Admin Backend',
    name126: 'Are you sure to delete this user?',
    name127: 'Are you sure to disable Manufacturer App permission?',
    name128: 'Are you sure to enable Manufacturer App permission?',
    name129: 'Vehicle Sales Merchant',
    name130: 'Detailed Address',
    name131: 'Contact Phone',
    name132: 'Detailed Address:',
    name133: 'Contact Phone:',
    name134: 'House number, e.g.: Room 102, 1st Floor',
    name135: 'Add Franchisee List',
    name136: 'Edit Franchisee List',
    name137: 'Are you sure to delete this franchisee?',
    name138: 'Franchisee',
    name139: 'Workshop APP',
    name140: 'Are you sure to disable Workshop App permission?',
    name141: 'Are you sure to enable Workshop App permission?',
  },

  public: {
    name1: 'Please Select',
    name2: 'Merchant Type',
    name3: 'Query',
    name4: 'Reset',
    name5: 'Please Enter',
    name6: 'Select Date and Time',
    name7: 'Logout',
    name8: 'Lidian Cloud IoT Platform',
    name9: 'To',
    name10: 'Start Date',
    name11: 'End Date',
    name12: 'Upload',
    name13: 'Submit',
    name14: 'Cancel',
    name15: 'Start Month',
    name16: 'End Month',
    name17: 'Sent Successfully',
    name18: 'Modified Successfully',
    name19: 'All',
    name20: 'On',
    name21: 'Off',
    name22: 'Logout',
    name23: 'Prompt',
    name24: 'Confirm to delete current data?',
    name25: 'Confirm',
    name26: 'Confirm Password:',
    name27: 'Incorrect email format',
    name28: 'Please enter nickname or account',
    name29: 'Please enter such as:',
    name30: 'Deleted successfully!',
    name31: 'Deletion canceled',
    name32: 'Confirm to submit?',
    name33: 'Submission canceled',
    name34: 'Canceled',
    name35: 'Uploading, please wait...',
    name36: 'Uploaded file size cannot exceed 10MB!',
    name37: 'Download to view failure reason',
    name38: 'Please select attachment',
    name39: 'No Data',
    name40: 'Are you sure to delete this data?',
    name41: 'Added successfully',
    name42: 'Uploaded successfully',
    name43: 'Select Date',
    name44: 'Loading...',
    name45: 'Please select any level',
    name46: 'Failed to import vehicle model information?',
    name47: 'Vehicle Model Import Information',
    name48: 'Import vehicle model information successfully',
    name49: 'Last 6 Hours',
    name50: 'Last 1 Hour',
    name51: 'Last Login Time',
    name52: 'Confirm to delete current vehicle?',
    name53: 'Electronic Fence - Import IoT Information',
    name54: 'Abnormal Positioning Information',
    name55: 'Single Battery Voltage',
    name56: 'Data Acquisition Time:',
    name57: 'Single Battery Voltage (V)',
    name58: 'Serial Number',
    name59: 'Beidou Positioning Abnormality',
    name60: 'Abnormal',
    name61: 'Please enter title',
    name62: 'Please select cover image',
    name63: 'This ride has no route',
    name64: 'File uploaded successfully. Please check the download result',
    name65: 'File size must not exceed 50M',
    name66: 'Only .xlsx files are allowed',
    name67: 'File size must not exceed 1MB!',
    name68: 'Are you sure you want to delete this route book?',
    name69: 'Please select an image',
    name70: 'Please select a serial port first',
    name71: 'Failed to open serial port',
    name72: 'Send content is empty',
    name73: 'Please open the serial port before sending data',
    name74: 'Only 1 file can be selected',
    name323: 'This vehicle ID does not exist or is not bound to a manufacturer, cannot submit',
  },

  account: {
    name1: 'Modify Email',
    name2: 'User-defined Messages',
    name3: 'User-defined Time Zone',
    name4: 'Confirm',
    name5: 'My Account',
    name6: 'Language Switch',
    name7: 'Please enter new email',
    name8: 'OK',
    name9: 'Cancel',
    name10: 'Simplified Chinese',
    name11: 'English',
    name12: 'My',
    name13: 'No sales records',
    name14: 'Add Sales Record',
    name15: 'No maintenance records',
    name16: 'Add Maintenance Record',
    name17: 'Scan Recognition',
    name18: 'Sales Time',
    name19: 'Upload Invoice',
    name20: 'Submit sales record?',
    name21:
      'Please click the three dots in the upper right corner, then click to re-enter the mini program. Please click to allow the application to use the camera when taking photos for recognition',
    name22: 'Please enter vehicle ID',
    name23: 'View Invoice',
    name24: 'No more data',
    name25: 'ID',
    name26: 'Maintenance Site Photos',
    name27: '(Up to 9 photos)',
    name28: 'ID:',
    name29: 'User Login',
    name30: 'Hello, welcome to login',
    name31: 'Please enter mobile phone number/email',
    name32: 'Register Account',
    name33: 'Switch',
    name34: 'Mobile Phone Registration',
    name35: 'Email Registration',
    name36: 'Name',
    name37: 'Nickname',
    name38: 'Store Address',
    name39: 'Return to Login',
    name40: 'Agree and Read',
    name41: '《User Agreement and Privacy Policy》',
    name42: 'User Agreement and Privacy Policy',
    name43: 'Set Login Password',
    name44: 'After setting the password, you can log in with the new password',
    name45: 'Mobile Phone Number',
    name46: 'Email',
    name47: 'Modify Time Zone',
    name48: 'Please check the user agreement and privacy policy',
    name49: 'Time Zone Mismatch',
    name50: 'Your device time zone is "{browser}", which differs from your user-defined time zone "{account}" in Settings. This may affect time display and queries. Please adjust the time zone in Settings or align your device time zone with your account.',
  },
  screen: {
    name1: 'Positioning',
    name167: 'Vehicle Distribution Fence',
    name169: 'Coordinates',
    name170: 'Longitude',
    name171: 'Latitude',
    name110: 'Operation',
    name111: 'Modify',
    name112: 'Delete',
    name168: 'Save',
    name79: 'Cancel',
    name95: 'Add',
    name172: 'Save Coordinate System',
    name173: 'Please save the edited coordinates first',
    name174: 'New Coordinates',
    name175: 'Please save the edited coordinates first',
    name2: 'Title:',
    name3: 'Title',
    name4: 'Su ICP Bei 2023025954-3',
    name5: 'Please enter push information',
    name6: 'Please enter new password',
    name7: 'Please re-enter new password',
    name8: 'Please enter account',
    name9: 'Are you sure to unbind this vehicle?',
    name10: 'Password modified successfully',
    name11: 'Please select users to push',
    name12: 'Push successful',
    name13: 'Location:',
    name14: 'Are you sure to delete this account?',
    name15: 'Please enter manufacturer name',
    name16: 'Are you sure to delete this manufacturer?',
    name17: 'Are you sure to disable this manufacturer?',
    name18: 'Are you sure to enable this manufacturer?',
    name19: 'Please enter identity name',
    name20: 'Please select whether to enable',
    name21: 'Administrator',
    name22: 'Salesperson',
    name23: 'Are you sure to delete this role?',
    name24: 'Please select platform',
    name25: 'Please select role',
    name26: 'Please search and select address',
    name27: 'Please enter contact phone number',
    name28: 'Please enter franchisee name',
    name29: 'Please select franchisee',
    name30: 'Please enter merchant name',
    name31: 'Please select address',
    name32: 'Please select merchant type',
    name33: 'Are you sure to disable this merchant?',
    name34: 'Are you sure to enable this merchant?',
    name35: 'Level 1',
    name36: 'Level 2',
    name37: 'Level 3',
    name38: 'Button',
    name39: 'Please enter menu Chinese name',
    name40: 'Please enter menu English name',
    name41: 'Please enter route address',
    name42: 'Are you sure to delete this data?',
    name43: 'Are you sure to disable this permission rule?',
    name44: 'Are you sure to enable this permission rule?',
    name45: 'System Log',
    name46: 'Modify Mobile Phone Number',
    name47: 'Please enter new mobile phone number',
    name48: 'Email modified successfully',
    name49: 'Mobile phone number modified successfully',
    name50: 'Newly Proposed',
    name51: 'Viewed',
    name52: 'Processing',
    name53: 'Rejected',
    name54: 'Closed',
    name55: 'Feedback Details',
    name230: 'Add Coordinate Point',
    name322: 'This card is not activated',
  },
  apiMessage: {
    name1: 'IoT ID must not exceed 2000 characters',
    name2: 'IoT not warehoused',
    name3: 'IoT not warehoused!',
    name4: 'IoT ID already exists!',
    name5: 'MAC address already exists!',
    name6: 'You only have 3 sharing opportunities!',
    name7: 'Hello, failed to get verification code. This e-bike has been bound by another user!',
    name8: 'You are not authorized to modify!',
    name9: 'You are not authorized to modify this vehicle!',
    name10: 'You are not authorized to delete this vehicle!',
    name11: 'You are not authorized to delete this riding record!',
    name12: 'You are not authorized to modify!',
    name13: 'You are not authorized to operate!',
    name14: 'You are not authorized to operate this route book!',
    name15: 'You are not authorized to operate this route book!',
    name16: 'You are not authorized to operate this vehicle!',
    name17: 'You are not authorized to view!',
    name18: 'You are not authorized to access this vehicle!',
    name19: 'You are not authorized to access this vehicle!',
    name20: 'You are not authorized to access the vehicle!',
    name21: 'You cannot access this vehicle!',
    name22: 'You do not have this vehicle!',
    name23: 'You do not have permission to operate this vehicle!',
    name24: 'Failed to update information!',
    name25: 'Share authorization ID is empty!',
    name26: 'Share authorization does not exist!',
    name27: 'Invalid share verification, cannot disable!',
    name28: 'Failed to delete share authorization!',
    name29: 'Historical riding record cannot be empty!',
    name30: 'Feedback information does not exist!',
    name31: 'Incorrect feedback status setting!',
    name32: 'Disarm anti-theft timeout!',
    name33: 'Fence does not exist!',
    name34: 'Fence does not exist at all!',
    name35: 'Fence points cannot be empty!',
    name36: 'Fence vehicle does not exist!',
    name37: 'Fence vehicle already exists!',
    name38: 'Firmware does not exist!',
    name39: 'Firmware information does not exist!',
    name40: 'Header error!',
    name41: 'Submenus exist, cannot delete',
    name42: 'Role-menu bindings exist, cannot delete',
    name43: 'Password must contain numbers, upper and lower case letters, special characters, and be longer than 8 characters',
    name44: 'Duplicate data already exists!',
    name45: 'Enable anti-theft timeout!',
    name46: 'Failed to get WeChat mini program authorization information!',
    name47: 'You cannot operate on this vehicle!',
    name48: 'You are not authorized to view the riding track!',
    name49: 'You cannot access this vehicle!',
    name50: 'You cannot access the vehicle!',
    name51: 'Header error!',
    name52: 'Permission identifier for button type cannot be empty',
    name53: 'Data exception!',
    name54: 'Vehicle number already exists',
    name55: 'File name is too long!',
    name56: 'No operation permission!',
    name57: 'Not authorized to modify this fence!',
    name58: 'Not authorized to delete this fence!',
    name59: 'Not authorized to access!',
    name60: 'Not authorized to access!',
    name61: 'No permission for this operation',
    name62: 'Unable to get binding information. The phone number you entered does not match the preset phone number!',
    name63: 'Pagination data not found!',
    name64: 'No Excel data detected!',
    name65: 'Insufficient permissions!',
    name66: 'Title error!',
    name67: 'This version number already exists, please re-enter!',
    name68: 'User vehicle does not exist!',
    name69: 'User riding record does not exist!',
    name70: 'E-bike already exists!',
    name71: 'SMS registration limit reached for today, please try again tomorrow!',
    name72: 'Failed to disable share verification!',
    name73: 'Tenant does not exist!',
    name74: 'Tenant information does not exist!',
    name75: 'System exception!',
    name76: 'System menu ID cannot be empty',
    name77: 'System menu does not exist',
    name78: 'Failed to get WeChat mini program user information!',
    name79: 'Failed to get WeChat mini program user phone number!',
    name80: 'Component path for menu type cannot be empty',
    name81: 'Table header error!',
    name82: 'Duplicate role name',
    name83: 'Unlock timeout!',
    name84: 'This fence does not exist!',
    name85: 'Ignore request does not exist, cannot ignore!',
    name86: 'This contact does not exist!',
    name87: 'This contact already exists!',
    name88: 'This account is not bound to a phone number',
    name89: 'This route book does not exist!',
    name90: 'This vehicle model does not exist!',
    name91: 'This vehicle does not exist!',
    name92: 'This vehicle does not exist, please confirm!',
    name93: 'This vehicle does not belong to you!',
    name94: 'This vehicle already exists!',
    name95: 'This vehicle is currently in use!',
    name96: 'This vehicle is currently locked, please try again later!',
    name97: 'This vehicle is in use!',
    name98: 'Vehicle ID cannot be empty!',
    name99: 'Please enter vehicle model information first!',
    name100: 'Please fill in the settings information!',
    name101: 'Please enter parameters correctly!',
    name102: 'Please select a vehicle!',
    name103: 'Please select a manufacturer!',
    name104: 'Please select and enter maintenance information!',
    name105: 'Failed to read EXCEL, please check if the file format is abnormal!',
    name106: 'Failed to read EXCEL, please check if the file format is abnormal!',
    name107: 'Failed to call traffic query API!',
    name108: 'Route book does not exist!',
    name109: 'Vehicle model does not exist!',
    name110: 'Vehicle model does not exist!',
    name111: 'Vehicle model information does not exist!',
    name112: 'Vehicle model ID already exists!',
    name113: 'Vehicle is offline!',
    name114: 'Vehicle does not exist!',
    name115: 'Vehicle does not exist!',
    name116: 'Vehicle does not exist, please confirm!',
    name117: 'Vehicle information does not exist!',
    name118: 'Vehicle information does not exist!',
    name119: 'Vehicle information already exists!',
    name120: 'Vehicle information already exists!',
    name121: 'Vehicle lock timeout!',
    name122: 'Vehicle has been bound by someone else!',
    name123: 'Vehicle not found!',
    name124: 'Vehicle ID does not exist!',
    name125: 'Vehicle ID cannot be empty!',
    name126: 'Vehicle debug report does not exist!',
    name127: 'Returned user does not exist!',
    name128: 'Enter transport mode timeout!',
    name129: 'Issue does not exist!',
    name130: 'Feedback does not exist!',
    name131: 'Incorrect riding ID!',
    name132: 'Riding ID cannot be empty!',
    name133: 'Operation successful',
    name134: 'Operation failed',
    name135: 'Incorrect parameters',
    name136: 'Parameter validation failed',
    name137: 'Not logged in or token expired, please log in!',
    name138: 'User cache has expired, please clear cache and log in again',
    name139: 'No relevant permission',
    name140: 'Related data not found',
    name141: 'System exception',
    name142: 'SQL exception',
    name143: 'Header error!',
    name144: 'Excel data not detected!',
    name145: 'The uploaded file object does not exist.',
    name146: 'File directory creation failed.',
    name147: 'Target file creation failed.',
    name148: 'File does not exist',
    name149: 'The maximum allowed file upload is {maxSize}G, with a current file size of {currentSize}G',
    name150: 'This SIM card does not exist on the carrier platform!',
    name151: 'Failed to parse traffic data!',
    // —— backend fail()/BusinessException() previously unmapped messages ——
    name152: 'Failed to download temporary file!',
    name153: 'No permission to access this vehicle data',
    name154: 'Unauthorized access!',
    name155: 'Please select a manufacturer!',
    name156: 'License plate number cannot be empty!',
  },
  importFailReason: {
    name1: 'Import failed: vehicle model name is duplicated!',
    name2: 'Import failed: vehicle model ID cannot be empty!',
    name3: 'Import failed: vehicle certificate photo cannot be empty!',
    name4: 'Import failed: frame number cannot be empty!',
    name5: 'Import failed: MAC address cannot be empty!',
    name6: 'Import failed: MAC address cannot be empty!',
    name7: 'Import failed: MAC address cannot be empty!',
    name8: 'Import failed: IoT ID cannot be empty!',
    name9: 'Import failed: IoT is already bound to a vehicle!',
    name10: 'Import failed: IoT is not in inventory!',
    name11: 'Import failed: IoT ID cannot be empty!',
    name12: 'Import failed: IoT ID cannot be empty!',
    name13: 'Import failed: CCC certificate number cannot be empty!',
    name14: 'Import failed: product name cannot be empty!',
    name15: 'Import failed: charger model exceeds 100 characters!',
    name16: 'Import failed: charger standard exceeds 100 characters!',
    name17: 'Import failed: manufacturer or trademark cannot be empty!',
    name18: 'Import failed: invalid manufacture date format (yyyy-MM-dd)!',
    name19: 'Import failed: wheelbase cannot be empty!',
    name20: 'Import failed: recommended service life cannot be empty!',
    name21: 'Import failed: controller ID cannot be empty!',
    name22: 'Import failed: database write failed!',
    name23: 'Import failed: database write failed!',
    name24: 'Import failed: vehicle cannot be empty!',
    name25: 'Import failed: vehicle information does not exist!',
    name26: 'Import failed: vehicle ID already exists!',
    name27: 'Import failed: model cannot be empty!',
    name28: 'Import failed: IoT device does not exist!',
    name29: 'Import failed: IoT ID cannot be empty!',
    name30: 'Import failed: IoT ID cannot be empty!',
    name31: 'Import failed: no vehicle information for this IoT ID!',
    name32: 'Import failed: factory and address cannot be empty!',
    name33: 'Import failed: production/manufacture date cannot be empty!',
    name34: 'Import failed: invalid production/manufacture date (yyyy-MM-dd)!',
    name35: 'Import failed: motor power and rated voltage cannot be empty!',
    name36: 'Import failed: motor ID cannot be empty!',
    name37: 'Import failed: motor ID cannot be empty!',
    name38: 'Import failed: battery type cannot be empty!',
    name39: 'Import failed: battery ID cannot be empty!',
    name40: 'Import failed: certificate information has changed!',
    name41: 'Import failed: invalid certificate expiry date format (yyyy-MM-dd)!',
    name42: 'Import failed: invalid certificate expiration date format (yyyy-MM-dd)!',
    name43: 'Import failed: vehicle is already bound to another certificate!',
    name44: 'Import failed: do not modify another manufacturer\'s vehicle information!',
    name45: 'Import failed: vehicle model name cannot be empty!',
    name46: 'Import failed: vehicle model already exists!',
    name47: 'Import failed: vehicle model ID cannot be empty!',
    name48: 'Import failed: vehicle model ID cannot be empty!',
    name49: 'Import failed: vehicle model ID is duplicated!',
    name50: 'Import failed: frame number cannot be empty!',
    name51: 'Import failed: vehicle code cannot be empty!',
    name52: 'Import failed: vehicle code is duplicated!',
    name53: 'Import failed: vehicle information does not exist!',
    name54: 'Import failed: vehicle certificate cannot be empty!',
    name55: 'Import failed: vehicle certificate cannot be empty!',
    name56: 'Import failed: vehicle model and name do not match preset data!',
    name57: 'Import failed: vehicle ID cannot be empty!',
    name58: 'Import failed: vehicle ID cannot be empty!',
    name59: 'Import failed: vehicle ID is duplicated!',
    name60: 'Import failed: vehicle code cannot be empty!',
    name61: 'Import failed: vehicle code location cannot be empty!',
    name62: 'Import failed: vehicle code is duplicated!',
    name63: 'Import failed: nameplate location cannot be empty!',
    name64: 'Import failed: length/width/height cannot be empty!',
    name65: 'Import failed: drive mode cannot be empty!',
    name66: 'These data have already been imported into the database; no need to import again!',
    name67: 'Input failed, cannot modify this IoT information!',
    name68: 'These data have already been imported into the database; no need to re-import!',
    name69: 'Allocation successful!',
    name70: 'Import failed: charger unique ID cannot be empty!',
    name71: 'Import failed: charger manufacturer cannot be empty!',
    name72: 'Import failed: charger unique ID already exists!',
    name73: 'Import failed: charger manufacturer exceeds 255 characters!',
    macMismatch: 'Import failed: vehicle {ebikeId} already exists, but MAC address does not match!',
  },
  dataSummary: {
    name1: 'App Quantity',
    name2: 'User Quantity',
    name3: 'New User Quantity This Month',
    name4: 'Management System Login Status',
    name5: 'System Function Usage Status',
    name6: 'System Features',
  },
  error404: {
    name1: 'Oops~ The page you visited does not exist',
    name2: 'Back to Home',
    name3: 'Go Back',
    name4: 'Clear Login Cache',
  },
  navTabBar: {
    name1: 'User Management',
    name2: 'Configuration Management',
    name3: 'Role Management',
    name4: 'Scheduled Task Compensation',
  },
  faultStats: {
    name1: 'Type 1',
    name2: 'Type 2',
    name3: 'Faults Today',
    name4: 'Yesterday',
    name5: 'vs. Same Time Yesterday',
    name6: 'Total Faults',
    name7: 'Fault Statistics',
    name8: 'All Manufacturers',
    name9: 'Merchant 1',
    name10: 'Merchant 2',
    name11: 'Fault Count',
    name12: 'Export',
    name13: 'Fault Type Distribution',
    name14: 'Direct',
    name15: 'Marketing',
    name16: 'Search Engine',
    name17: 'Email',
    name18: 'Union Ads',
    name19: 'Video Ads',
    name20: 'Baidu',
    name21: 'Google',
    name22: 'Bing',
    name23: 'Others',
  },
  map: {
    name1: 'Damaged',
    name2: 'Normal',
    name3: 'Time Query',
    name4: 'Certified Vehicle Query',
    name5: 'All Vehicle Query',
    name6: '12 Hours',
    name7: '24 Hours',
    name8: '36 Hours',
    name9: '48 Hours',
    name10: 'Vehicle Email',
    name11: 'IoT ID',
    name12: 'Lock Status',
  },
}
